import { apiRequestDev } from './apiRequest';

export const getAllWidgets = async (config) => apiRequestDev(config, '/widgets/all');

export const assignWidgets = async (config, activeRidingId, activeWidgetsList) => {
  return apiRequestDev(config, '/widgets/assign', 'post', {
    riding_id: activeRidingId,
    widgets: activeWidgetsList,
  });
};
